const cartPopupOpenTrigger = $('[data-cart-popup-open]');
const cartPopup = $('aside.cart-popup-section');
const cartPopupBg = $('[data-popup-bg]');

$(function () {
	cartQtyUpdate();
	loginCheck();
	loginCheckMobile();
	updateCartContent(true);
});



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CART POPUP

cartPopupOpenTrigger.on('click', function() {
	cartPopupShow(false);
});


$(document).on('click', '[data-cart-popup-close]', async function(e) {
	e.preventDefault();
	cartPopupHide();
});


$(document).on('click', function(e) {
    const target = $(e.target);

    const isOutsideCartTrigger = !cartPopupOpenTrigger.is(target) && cartPopupOpenTrigger.has(target).length === 0;
    const isOutsideCartPopup = !cartPopup.is(target) && cartPopup.has(target).length === 0;
    const isQtyMinus = target.closest('.qty-minus').length > 0;

    if (isOutsideCartTrigger && isOutsideCartPopup && !isQtyMinus) {
        cartPopupHide();
    }
});

async function cartPopupShow(refreshCart) {
	const loader = $('[data-cart-loader]');
    try {
		cartPopup.animate({ scrollTop: 0 }, 400);
        cartPopup.attr('data-revealed', 'true');
        cartPopupBg.attr('data-revealed', 'true');
        $('body').attr('data-popup-expanded', 'true');
		if (refreshCart) {
			loader.css('display', 'flex');
        	await updateCartContent();
		}
    } catch (error) {
        console.error('Error updating cart content:', error);
    }
}

async function updateCartContent(checkCart = false) {
	if (!cartPopup.length) return false;
	
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/shop/cart/cart',
			type: 'GET',
			dataType: 'html',
			success: function(response) {
				cartPopup.html(response.replaceAll('data-cart-view="full"','data-cart-view="aside"').replaceAll('data-add-to-cart-refresh="true"','').replaceAll('>Continue shopping','data-cart-popup-close>Continue shopping'));
				if (checkCart && $('[data-checkout-silent]').length) {
					console.log('Check cart SILENT')
					cartUpdate($('[data-checkout-silent]'), true)
				}
				resolve();
			},
			error: function(xhr, status, error) {
				console.error('Failed to fetch cart content:', error);
				cartPopup.html(`
					<div data-cart-view="aside">
						<div class="cart-empty">
						There aren't any items in your cart.
						<div class="cart-btns">
							<a href="/shop" class="btn btn-black">Continue shopping</a>
						</div>
						</div>
						<div data-cart-loader>
						<img src="/dist/images/icons/loader.svg" width="200" height="200" alt="Loader"/>
						</div>
					</div>
				`);
				reject(error);
			}
		});
	});
}

function cartPopupHide() {
	cartPopup.attr('data-revealed', 'false');
	cartPopupBg.attr('data-revealed', 'false');
	$('body').attr('data-popup-expanded', 'false');
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PRODUCT QTY

function incrementValue(e) {
    e.preventDefault();
    var fieldClass = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('.' + fieldClass).val(), 10);
    var newVal = currentVal;
	var maxValue = parent.find('.' + fieldClass).attr('data-qty-max');

    if (!isNaN(currentVal)) {
		newVal = currentVal + 1;
    } else {
        newVal = 1;
    }
	// console.log('newVal 1 ' + newVal)
	parent.find('.' + fieldClass).val(newVal);
	parent.find('.' + fieldClass).trigger('change');

	if (newVal > maxValue) {
		newVal = maxValue;
		setTimeout(() => {
			parent.find('.' + fieldClass).val(newVal);
		}, 500);
	}
	// console.log('newVal 2 ' + newVal)
	
}

function decrementValue(e) {
    e.preventDefault();
    var fieldClass = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('.' + fieldClass).val(), 10);
	var newVal = currentVal;
	var maxValue = parent.find('.' + fieldClass).attr('data-qty-max');

    if (!isNaN(currentVal) && currentVal > 0 && currentVal-1 > -1) {
		newVal = currentVal - 1;
    } else {
        newVal = 1;
    }

	parent.find('.' + fieldClass).val(newVal);
	parent.find('.' + fieldClass).trigger('change');
}

$(document).on('click', '.qty-plus', function(e) {
    incrementValue(e);
});

$(document).on('click', '.qty-minus', function(e) {
    decrementValue(e);
});

async function cartQtyUpdate() {
	try {
		const response = await fetch('/actions/commerce/cart/get-cart', {
			headers: {
				'Accept': 'application/json',
			},
		});
		const data = await response.json();
		// console.log('cartQtyUpdate ' + data.cart.totalQty);
		$('[data-cart-items]').attr('data-cart-items', data.cart.totalQty);
		$('[data-cart-items]').text(data.cart.totalQty);
	} catch (error) {
		console.error('Error updating cart quantity:', error);
	}
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROMOCODE REVEAL

$(document).on('click', '[data-promocode-trigger]', function() {
    const block = $(this).closest('.cart-promocode-block');
    const isRevealed = block.attr('data-revealed') === 'true';
    block.attr('data-revealed', !isRevealed);
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LOGIN CHECK

async function loginCheckMobile() {
	var loginCont = $('.mobile-menu .column-login a');
	if (!loginCont.length) {
		return false;
	}
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/dynamic/login-mobile',
			type: 'GET',
			dataType: 'html',
			success: function(response) {
				$('.mobile-menu .column-login a.btn-login').text(response);
				resolve();
			},
			error: function(xhr, status, error) {
				console.error('Failed to fetch login content:', error);
				reject(error);
			}
		});
	});
}

async function loginCheck() {
	var loginCont = $('header .login-block');
	if (!loginCont.length) {
		return false;
	}
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/dynamic/login',
			type: 'GET',
			dataType: 'html',
			success: function(response) {
				loginCont.html(response);
				resolve();
			},
			error: function(xhr, status, error) {
				console.error('Failed to fetch login content:', error);
				reject(error);
			}
		});
	});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CHECK STOCK - SHOP

$(function () {
	var productEl = $('[data-product-id]');
	if (productEl.length) {
		productEl.each(async function() {
			var productId = $(this).attr('data-product-id');
			checkStock(productId);
		})
	}	
})

window.checkStock = async function checkStock(productId) {

    // console.log('CHECK STOCK for ' + productId)

    var requestURL = siteUrl + '/product/' + productId + '.json';

    // console.log('Fetching STOCK data...');
    // console.log(requestURL)

    try {
        const response = await $.ajax({
            type: 'get',
            url: requestURL,
        });
		
		if (!response.data[0]) return false;
        // console.log(response.data[0]);
		
		var el = $('[data-product-id="' + productId + '"]');

		var stock = response.data[0].stock;
		var onSale = response.data[0].onSale;
		var salePriceAsCurrency = response.data[0].salePriceAsCurrency;
		var priceAsCurrency = response.data[0].priceAsCurrency;

		if (stock <= 0) {
			el.find('.price').replaceWith('<p class="out-of-stock">Out of stock</p>');
			el.find('form').remove();
		}
		if (onSale) {
			el.find('.price').html(salePriceAsCurrency + ' <del>' + priceAsCurrency + '</del>');
		} else {
			el.find('.price').html(salePriceAsCurrency);
		}

    } catch (error) {
        console.log('Error fetching STOCK data');
        console.log(error);
    }

    return true;

}

$(document).on('change', '.qty-input[data-refresh-cart="true"]', async function(e) {
	$(this).closest('form').trigger('submit');
	if ($(this).val() == 0) {
		$(this).closest('[data-purchasable-id]').remove();
	}
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ADD TO CART

$(document).on('submit', 'form.cart-update', async function(e) {
	e.preventDefault();
	addToCart($(this));
});

function addToCart(form) {
	console.log('ADD TO CART')
    fetch('/actions/blitz/csrf/token')
		.then(response => response.text())
		.then(csrfToken => {
			console.log(csrfToken);
			var addToCartButton = form.find('[data-add-to-cart-button]');
			var refreshPage = addToCartButton.attr('data-add-to-cart-refresh') == 'true' ? true : false;
			var mini = addToCartButton.attr('data-add-to-cart-button') == 'mini' ? true : false;
			if (!mini) {
				addToCartButton.text('One moment...');
			} else {
				addToCartButton.addClass('spin');
				const loader = $('[data-cart-loader]');
				loader.css('display', 'flex');
				if (cartPopup.length) {
					cartPopup.animate({ scrollTop: 0 }, 400);
				}
			}
			var errorMessage = '';

			var data = new FormData(form[0]);
			data.append('CRAFT_CSRF_TOKEN', csrfToken);

			console.log('data')
			console.log(data)

			$.ajax({
				url: '/commerce/cart/update-cart',
				type: 'post',
				data: data,
				processData: false,
				contentType: false,
				success: function(response) {
					console.log(response);
					console.log(response.message);
					if (!mini) {
						addToCartButton.text(response.message);
						setTimeout(() => {
							addToCartButton.text('Add to cart');
						}, 1500);
					} else {
						addToCartButton.removeClass('spin');
					}
					if (refreshPage) {
						location.reload();
					}
					cartQtyUpdate();
					if (!refreshPage) {
						cartPopupShow(true);
					}
					if (errorMessage) {
						cartNotice('error', errorMessage);
					}
				},
				error: function (response) {
					console.log('Error');
					console.log(response);
                    console.log('Status:', response.status);
                    console.log('Status Text:', response.statusText);
                    console.log('Response Text:', response.responseText);
					if (mini) {
						addToCartButton.addClass('spin');
					}
					try {
                        var response = JSON.parse(response.responseText);
                        if (response.message) {
							errorMessage = errorMessage + response.message + ' ';
                        }
						for (var key in response.errors) {
							if (response.errors.hasOwnProperty(key)) {
								response.errors[key].forEach(function(error) {
									errorMessage = errorMessage + error + ' ';
								});
							}
						}
                        if (errorMessage.length) {
                            console.log('errorMessage:', errorMessage);
							if (errorMessage) {
								cartNotice('error', errorMessage);
							}

                        }
                    } catch (e) {
                        console.error('Failed to parse JSON response:', e);
                    }
				},
				dataType: 'json'
			});
		})
		.catch(error => {
			console.error('Error fetching CSRF token:', error);
		});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CART PAGE

$(document).on('click', '[data-shop-item-remove]', function(e) {
	console.log('data-shop-item-remove')
	$(this).parent().find('input[type="checkbox"]').prop('checked', true);
	$(this).closest('form').trigger('submit');
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DISCOUNT POPUP

$(document).on('submit', 'form[data-form-discount-popup]', async function(e) {
	e.preventDefault();
	addDiscount($(this));
});

function addDiscount(form) {
	console.log('ADD DISCOUNT')
	var errorBox = form.find('.popup-error');
	var button = form.find('button');
	errorBox.text('');
	button.text('One moment...');
	var successBox = form.find('.popup-success');
	successBox.text('');
	var data = form.serialize();
	return $.ajax({
		type: 'post',
		url: '/imagiccms?p=actions/order/order/create-discount',
		data: data,
		success: function (response) {
			console.log('Done');
			console.log(response);
			if (response.success) {
				form.addClass('hide-form');
				successBox.text(response.message);
				form.closest('aside').find('.description-bottom + [data-promo-popup-close]').text('Close');
				$.cookie('promo-popup-hide', true);
			} else {
				errorBox.text(response.message);
			}
			button.text('Get it now!');
		},
		error: function (response) {
			errorBox.text('Something went wrong, please try again.');
			button.text('Get it now!');
			console.log('Error');
			console.log(response);
		}
	});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CHECKOUT PROCESS

const formGuest = $('[data-checkout-guest]');
const formShipping = $('[data-checkout-shipping]');
const shippingBillingFields = ['fullName','addressLine1','locality','postalCode'];

$(document).on('submit', 'form[data-checkout]', async function(e) {
	e.preventDefault();
	try {
		const result = await cartUpdate($(this));
		if (result === 'success') {
			console.log('---> Updating cart PROMISE SUCCESS')
		}
	} catch (err) {
		console.error('Cart update failed', err);
	}
});

// CHECK CART ON LOAD SILENTLY

$(function () {
	if ($('[data-checkout-silent]').length) {
		console.log('Check cart SILENT')
		cartUpdate($('[data-checkout-silent]'), true)
	}
});

////


async function cartUpdate(form, silent = false) {

	return new Promise((resolve, reject) => {
		
		console.log('---> Updating cart, silent = ' + silent)
		
		const cartInfo = $('[data-cart-information]');
		const shippingScale = $('[data-shipping-scale]');
		const loader = $('[data-cart-loader]');
		var data = form.serialize();
		if (!silent) {
			loader.css('display', 'flex');
		}
		var removeLineItem = form.attr('data-checkout-line-item-remove') ? true : false;
		$.ajax({
			url: '/actions/commerce/cart/update-cart',
			type: 'post',
			data: data,
			success: async function(response) {
				console.log('---> Updating cart, success response = ')
				console.log(response);
				console.log('<---')

				if (removeLineItem) {
					form.closest('.line-item').remove();
				}

				var cart = response.cart;
				var allNotices = [...new Set(cart.notices.map(n => n.message))].join('<br>');
				var allErrors = '';

				console.log('cart.shippingMethodName ' + cart.shippingMethodName)
				if (cart.shippingMethodName === null) {
					cartInfo.find('[data-cart-total-shipping-cost]').text('calculated at checkout');
				} else if (cart.totalShippingCost == 0) {
					cartInfo.find('[data-cart-total-shipping-cost]').text('FREE');
				} else {
					cartInfo.find('[data-cart-total-shipping-cost]').text(cart.totalShippingCostAsCurrency);
				}
					
				cartInfo.find('[data-cart-total-tax-included]').text(cart.totalTaxIncludedAsCurrency);
				cartInfo.find('[data-cart-total-discount]').text(cart.totalDiscountAsCurrency);
				cartInfo.find('[data-cart-total-price]').text(cart.totalPriceAsCurrency);
				cartInfo.find('[data-cart-item-subtotal]').text(cart.itemSubtotalAsCurrency);
				cartInfo.find('[data-cart-couponcode]').text(cart.couponCode);
				var lineItems = response.cart.lineItems;
				lineItems.forEach(item => {
					var lineItemRow = $(`[data-purchasable-id="${item.purchasableId}"]`);
					if (lineItemRow.length) {
						lineItemRow.find('.qty-input').val(parseInt(item.qty));
						lineItemRow.find('[data-item-price]').text(item.priceAsCurrency);
						if (item.onSale) {
							lineItemRow.find('[data-item-price]').css('text-decoration','line-through');
						}
						lineItemRow.find('[data-item-sale-price]').text(item.salePriceAsCurrency);
						lineItemRow.find('[data-item-subtotal]').text(item.subtotalAsCurrency);
					}
				});
				if (shippingScale.length) {
					var freeShippingValue = parseInt(shippingScale.attr('data-free-shipping-value'));
					var freeShippingMessage = shippingScale.attr('data-free-shipping-message');
					var freeShippingGap = (freeShippingValue - cart.itemSubtotal).toFixed(2);
					var width = (cart.itemSubtotal / freeShippingValue) * 100;
					if (freeShippingGap > 0) {
						shippingScale.find('.message').text(`You are $${freeShippingGap} away from free shipping`);
						shippingScale.find('.note-free-shipping-range').css('display','flex');
						shippingScale.find('.range div').css('width', width + '%');
					} else {
						shippingScale.find('.message').text(freeShippingMessage);
						shippingScale.find('.note-free-shipping-range').hide();
					}
				}

				if (formShipping.length) {
					shippingBillingFields.forEach(function(fieldName) {
						['shippingAddress', 'billingAddress'].forEach(function(prefix) {
							const field = formShipping.find(`[name="${prefix}[${fieldName}]"]`);
							if (fieldName == 'postalCode') {
								if (field.val() !== '') {
									var isValid = /^\d{4}$/.test(field.val());
									if (!isValid) {
										if (prefix.startsWith('billingAddress.')) {
											allErrors = allErrors + 'Billing: Postal code must be 4 digits<br>';
										} else if (prefix.startsWith('shippingAddress.')) {
											allErrors = allErrors + 'Shipping: Postal code must be 4 digits<br>';
										}
									}
								}
							}
						});
					});

					if (!silent) {
						if (!cart.shippingMethodHandle) {
							allErrors = allErrors + 'Please select shipping method<br>';
						}
					}

					try {
						await checkoutShippingCheck(silent);
					} catch (err) {
						// Stop further steps if address is invalid
						loader.hide();
						return reject(err);
					}
				}

				if (cartPopup.length) {
					updateCartContent().then(() => {
						loader.hide();
					});
				} else {
					loader.hide();
				}

				var allNoticesAttr = cart.notices.map(n => n.attribute);
				if (allNoticesAttr) {
					console.log('--> Cart notices = ')
					console.log(allNoticesAttr)
					console.log('<--')
				}

				var hasCouponCodeNotice = allNoticesAttr.includes("couponCode");
				if (hasCouponCodeNotice) {
					cartInfo.find('[name="couponCode"]').val('');
				}

				if (allNotices) {
					cartNotice('warning', allNotices);
					return true;
				}
				
				if (allErrors) {
					cartNotice('error', allErrors);
					return true;
				}

				if (!silent) {
					cartNotice('success', response.message);
				}

				cartQtyUpdate();

				resolve('success');

			},
			error: function (response) {
				var responseMessage = JSON.parse(response.responseText);
				console.log('---> Updating cart, error response = ')
				console.log(responseMessage);
				console.log('<---')

				var allMessagesArray = [];

				if (responseMessage.errors) {
					for (const [key, messages] of Object.entries(responseMessage.errors)) {
						if (key.startsWith('billingAddress.')) {
							messages.forEach(msg => {
								allMessagesArray.push('Billing: ' + msg);
							});
						} else if (key.startsWith('shippingAddress.')) {
							messages.forEach(msg => {
								allMessagesArray.push('Shipping: ' + msg);
							});
						} else {
							messages.forEach(msg => {
								allMessagesArray.push(msg);
							});
						}
					}
				}

				var allMessages = allMessagesArray.join('<br>');
				var message = `<p>${responseMessage.message}<br>${allMessages}</p>`;

				if (!silent) {
					cartNotice('error', message);
				}

				loader.hide();

				reject(response);

			},
			dataType: 'json'
		});
	});
}


// SHIPPING/BILLING ADDRESS AUTO RESAVE WHEN FIELDS CHANGE

$(function () {
	let lastData = '';

	const buildSelectors = (prefix) => 
		shippingBillingFields.map(field => `input[name="${prefix}[${field}]"]`).join(', ');
	
	const selectorsShipping = buildSelectors('shippingAddress');
	const selectorsBilling = buildSelectors('billingAddress');

	const $watchedFields = formShipping.find(`${selectorsShipping}, ${selectorsBilling}, [name="shippingAddressId"], [name="billingAddressId"]`);

	function serializeWatchedFields() {
		return $watchedFields.serialize();
	}

	async function checkWatchedFields() {
		const currentData = serializeWatchedFields();

		if (currentData !== lastData) {
			lastData = currentData;
			console.log('Address fields changed, submitting form...');

			try {
				await cartUpdate(formShipping, true);
			} catch (err) {
				console.error('Cart update failed', err);
			}
		}
	}

	setInterval(checkWatchedFields, 1000);

	// check selected address
	if (formShipping.length && $('input[name="shippingAddressId"][checked]').length) {
		var block = $('input[name="shippingAddressId"][checked]').closest('.checkout-address-block');
		block.addClass('is-selected');
		block.find('.checkout-input-checkbox input').prop('checked',true);
		block.find('.checkout-input-checkbox input').trigger('change');
	}
	if (formShipping.length && $('input[name="billingAddressId"][checked]').length) {
		var block = $('input[name="billingAddressId"][checked]').closest('.checkout-address-block');
		block.addClass('is-selected');
		block.find('.checkout-input-checkbox input').prop('checked',true);
		block.find('.checkout-input-checkbox input').trigger('change');
	}


    $('#shippingAddress-postalCode, #billingAddress-postalCode, #postalCode').on('input', function() {
        const postalCode = $(this).val();
        if (!/^\d{0,4}$/.test(postalCode)) {
            this.setCustomValidity("Postal code must be 4 digits");
        } else {
            this.setCustomValidity("");
        }
    });


	// ADD EDIT ADDRESS
	if (formShipping.length) {
		const params = getUrlParams();
		const addressGroupName = params.name;
		const addressId = params.addressId;

		if (addressGroupName && addressId) {
			if (addressGroupName != 'billingAddressNew' && addressGroupName != 'shippingAddressNew') {
				var block = $('input[name="' + addressGroupName + 'Id"][value="' + addressId + '"]').closest('.checkout-address-block').find('label');
				block.trigger('click');
			} else {
				if (addressGroupName == 'billingAddressNew') {
					var block = $('.js-address-fieldset.BillingAddress').find('.checkout-address-block').last().find('label');
				}
				if (addressGroupName == 'shippingAddressNew') {
					var block = $('.js-address-fieldset.ShippingAddress').find('.checkout-address-block').last().find('label');
				}
			}
			const newUrl = window.location.origin + window.location.pathname;
			window.history.replaceState({}, document.title, newUrl);
		} else if (addressGroupName == 'billingAddressNew' || addressGroupName == 'shippingAddressNew') {
			if (addressGroupName == 'billingAddressNew') {
				var block = $('.js-address-fieldset.BillingAddress').find('.checkout-address-block').last().find('label');
			}
			if (addressGroupName == 'shippingAddressNew') {
				var block = $('.js-address-fieldset.ShippingAddress').find('.checkout-address-block').last().find('label');
			}
			block.trigger('click');
			const newUrl = window.location.origin + window.location.pathname;
			window.history.replaceState({}, document.title, newUrl);
		}
	}

});



$(document).on('click', '[data-checkout-shipping-continue]', async function(e) {
	try {
		const result = await cartUpdate(formShipping);
		if (result === 'success') {
			window.location.href = '/shop/checkout/payment'; // or your desired URL
		}
	} catch (err) {
		console.error('Cart update failed', err);
	}
});


$(document).on('change', 'input[name="shippingAddressId"]', function() {
    // Remove the class from all parents first
    $('input[name="shippingAddressId"]').each(function() {
		var block = $(this).closest('.checkout-address-block');
        block.removeClass('is-selected');
		block.find('.checkout-input-checkbox input').prop('checked', false);
		block.find('.checkout-input-checkbox input').trigger('change');
    });
	var block = $(this).closest('.checkout-address-block');
    // Add the class to the newly selected one
    block.addClass('is-selected');
	block.find('.checkout-input-checkbox input').prop('checked', true);
	block.find('.checkout-input-checkbox input').trigger('change');
});

$(document).on('change', 'input[name="billingAddressId"]', function() {
    // Remove the class from all parents first
    $('input[name="billingAddressId"]').each(function() {
		var block = $(this).closest('.checkout-address-block');
        block.removeClass('is-selected');
		block.find('.checkout-input-checkbox input').prop('checked', false);
		block.find('.checkout-input-checkbox input').trigger('change');
    });
	var block = $(this).closest('.checkout-address-block');
    // Add the class to the newly selected one
    block.addClass('is-selected');
	block.find('.checkout-input-checkbox input').prop('checked', true);
	block.find('.checkout-input-checkbox input').trigger('change');
});




const shippingOptionsContainer = $('[data-checkout-shipping-options]');

async function checkoutShippingCheck(silent = false) {
	console.log('---> Checking address')
	var data = $('[data-checkout-shipping]').serialize();
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/actions/order/order/check-address',
			type: 'post',
			data: data,
			success: function(response) {
				console.log('---> Checking address, success response =')
				console.log(response)
				console.log('<---')
				var isValid = /^\d{4}$/.test(response.postalCode);
				if (!isValid) {
					if (!silent) {
						cartNotice('error', 'Shipping: Postal code must be 4 digits');
					}
					shippingOptionsContainer.empty();
					shippingOptionsContainer.parent().find('.checkout-shipping-option-note').show();
					reject('Invalid postal code');
				} else {
					checkoutShippingMethods(response.postalCode)
					resolve('Valid');
				}
			},
			error: function(xhr) {
				console.log('---> Checking address, error response =')
				console.error(xhr);
				console.log('<---')
				reject('AJAX error');
			}
		});
	});
}

async function checkoutShippingMethods(postalCode) {
	console.log('---> Shipping methods')
	var data = $('[data-checkout-shipping]').serialize();
	$.ajax({
		url: '/actions/order/order/get-shipping-methods',
		type: 'post',
		data: data,
		success: function(response) {
			console.log('---> Shipping methods, success response =')
			console.log(response)
			console.log('<---')

			shippingOptionsContainer.empty();
			shippingOptionsContainer.parent().find('.checkout-shipping-option-note').hide();

			var methods = response.methods;

			if (methods.length == 0) {
				shippingOptionsContainer.append('<div class="checkout-shipping-option-note">No shipping methods available</div>');
			}

			// Loop through shipping methods
			Object.values(methods).forEach(function(methodData, index) {
				const method = methodData.shippingMethod;
				const methodSelectedHandle = response.selected ? response.selected.handle : false;
				const id = `shipping-method-${method.id}`;
				const radio = `
					<div class="shipping-method-option">
						<input type="radio" 
							id="${id}" 
							name="shippingMethodHandle" 
							value="${method.handle}" 
							${method.handle === methodSelectedHandle ? 'checked' : ''}>
						<label for="${id}">
							<span>${method.name}</span><span>${methodData.price > 0 ? methodData.priceAsCurrency : 'FREE'}</span>
						</label>
					</div>
				`;

				shippingOptionsContainer.append(radio);
			});

		},
		error: function(response) {
			var responseMessage = JSON.parse(response.responseText);
			console.log('---> Shipping methods, error response =')
			console.log(responseMessage)
			console.log('<---')
		}
	});
}

$(document).on('click', '[name="shippingMethodHandle"]', async function(e) {
	e.preventDefault();
	$(this).prop('checked');
	formShipping.trigger('submit');
});


// CHECKOUT EMAIL

let allowSubmitRegister = false;
let allowSubmitGuest = false;

$(document).on('submit', '[data-checkout-register-form]', async function(e) {
	var form = $(this);
	console.log('allowSubmitRegister ' + allowSubmitRegister)
	if (allowSubmitRegister) return;
	e.preventDefault();
	try {
		const result = await cartUpdate(form, true);
		if (result === 'success') {
			console.log('---> Updating cart USER FORM PROMISE SUCCESS')
			allowSubmitRegister = true;
			$(this).submit();
		}
	} catch (err) {
		console.error('Cart update failed', err);
	}
});

$(document).on('click', '[data-checkout-guest-btn]', async function(e) {
	var form = $('[data-checkout-register-form]');
	form.find('input[required]').removeAttr('required');
	form.find('[name="saveShippingAddressOnOrderComplete"]').val(0);
	form.find('[name="saveBillingAddressOnOrderComplete"]').val(0);
	form.find('[name="registerUserOnOrderComplete"]').val(0);
	console.log('allowSubmitGuest ' + allowSubmitGuest)
	if (allowSubmitGuest) return;
	e.preventDefault();
	try {
		const result = await cartUpdate(form, true);
		if (result === 'success') {
			console.log('---> Updating cart GUEST FORM PROMISE SUCCESS')
			// window.location.replace('/shop/checkout/shipping');
			allowSubmitGuest = true;
			$(this).submit();
		}
	} catch (err) {
		console.error('Cart update failed', err);
	}
});

/////



$('textarea[name="fields[specialNotes]"]').on('input', function () {
	$(this).css('height', 'auto'); // Reset height to calculate new scroll height
	$(this).css('height', this.scrollHeight + 'px'); // Set height to match the content
});

// MOBILE CART EXPAND

$(document).on('click', '[data-cart-expand]', function(e) {
	$('.section-checkout [data-cart-information]').slideToggle();
});


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CHECKOUT NOTICES

$(document).on('submit', 'form[data-checkout-clear-notices]', async function(e) {
	e.preventDefault();
	cartClearNotices($(this));
});

function cartClearNotices(form) {
	console.log('cartClearNotices')
	var data = form.serialize();
	$.ajax({
		url: '/commerce/cart/update-cart',
		type: 'post',
		data: data,
		success: function(response) {
			console.log(response);
		},
		error: function (response) {
			console.log('Error');
			console.log(response);
		},
		dataType: 'json'
	});
}


let cartNoticeTimeout;
function cartNotice(status, message) {
	clearTimeout(cartNoticeTimeout);
	const cartNotices = $('[data-cart-notices]');
	var messageEl = cartNotices.find('.message')
	cartNotices.attr('data-status', status);
	messageEl.html(message);
	cartNotices.attr('data-visible','true');
	cartNoticeTimeout = setTimeout(() => {
		cartNotices.attr('data-visible','false');
		cartNotices.attr('data-status', '');
		cartNotices.find('form').trigger('submit');
		messageEl.html('');
	}, 5000);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HELPERS

function getUrlParams() {
	const params = {};
	const queryString = window.location.search.substring(1);
	const pairs = queryString.split('&');

	pairs.forEach(function(pair) {
		const [key, value] = pair.split('=');
		if (key) {
			params[decodeURIComponent(key)] = decodeURIComponent(value || '');
		}
	});

	return params;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
